import { kebabCase } from '@fergdigitalcommerce/fergy-utilities';
import { type CarouselContent, type ContentComponent } from '../../../../../types/construct.types';
import { HomeCarousel } from '../../../../home-components/home-carousel/home-carousel.component';

export const CarouselHandler: ContentComponent<CarouselContent> = ({
	content: {
		fields: {
			title,
			carousel: { items }
		}
	}
}) => {
	return <HomeCarousel items={items} title={title} automationHook={`${kebabCase(title || '')}-swipe`} />;
};
